 <template>
	<div class="buttons has-addons is-centered" style="margin:0px">
		<span @click="setFilterType('deferred')" :class='{"selected deferred": isSelected("deferred")}' class="button segment-button">
			<md-icon v-show="isSelected('deferred')" :class='{"deferred-icon": isSelected("deferred")}'>alarm</md-icon>
			<md-icon v-show="!isSelected('deferred')">alarm</md-icon>
		</span>
		<span @click="setFilterType('inbox')" :class='{"selected inbox": isSelected("inbox")}' class="button segment-button">
			<md-icon v-show="isSelected('inbox')" :class='{"inbox-icon": isSelected("inbox")}'>inbox</md-icon>
			<md-icon v-show="!isSelected('inbox')">inbox</md-icon>
		</span>
		<span @click="setFilterType('done')" :class='{"selected done": isSelected("done")}' class="button segment-button">
			<md-icon v-show="isSelected('done')" :class='{"done-icon": isSelected("done")}'>done</md-icon>
			<md-icon v-show="!isSelected('done')">done</md-icon>
		</span>
	</div>
</template>

<script>
export default {
	name: 'TypeFilter',
	mounted: function () {
		this.$store.dispatch('tabs/setFilterType', 'inbox')
	},
	methods: {
		setFilterType: function (type) {
			this.$store.dispatch('tabs/setFilterType', type)
			// this.$store.dispatch('tabs/searchTabs')
			scrollTo(0, 0)
		},
		isSelected (type) {
			return this.$store.state.tabs.filterType === type
		}
	}
}
</script>

<style scoped>
.selected {
	/* border: solid 0.5px !important; */
	/* border-color: lightgray !important; */
}
.deferred {
	/* color: #FFA500 !important;
	background-color: white !important; */
	background-color: #FFA500 !important;
	color: white !important;
}
.inbox {
	background-color: #6EBD91 !important;
	color: white !important;
}
.done {
	background-color: #1E2D47 !important;
	color: white !important;
}
.deferred-icon {
	/* color: #FFA500 !important; */
	color: white !important;
}
.inbox-icon {
	/* color: #6EBD91 !important; */
	color: white !important;
}
.done-icon {
	/* color: #1E2D47 !important; */
	color: white !important;
}
.selected-icon {
	color: white !important;
}
.segment-button {
	margin:0px !important;
	padding: 0px 24px;
	background: #CCD6DF;
	border: none;
}
</style>
